import companiesComponent     from './companies.component';
import companiesService       from './companies.service';
import companiesRouter        from './companies.router';

import companiesListModule    from './companies-list/companies-list';
import companiesDetailModule  from './companies-detail/companies-detail';
import companiesUpdateModule  from './companies-update/companies-update';
import companiesCreateModule  from './companies-create/companies-create';
import {getHumanReadableAccountById} from "./getHumanReadableAccountById.filter";

const companiesModule = angular
  .module('companies', [
    companiesListModule.name,
    companiesDetailModule.name,
    companiesUpdateModule.name,
    companiesCreateModule.name
  ])
  .config( companiesRouter )
  .service('$companies', companiesService)
  .component('adminCompanies', companiesComponent)
  .filter('getHumanReadableAccountById', getHumanReadableAccountById);

export default companiesModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies.js
 **/